import React, {useContext, useEffect, useState} from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import Image from '../../utils/Elements/Image';
import CompaniesNav from './components/CompaniesNav';
import { jwtDecode } from 'jwt-decode';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import { CompanyForm } from '../Companies/CompanyForm';
import { ContactForm } from '../Contacts/ContactForm';
import { ActivityForm } from '../Activities/ActivityForm';
import { CountContext, ParentContext, CompanyContext, ActivityContext } from "../../layouts/Dashboard/LayoutDashboard";

export const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {

  const classes = classNames(
    'site-header',
    bottomOuterDivider && 'has-bottom-divider',
    className
  );

  const isProduction = process.env.NODE_ENV === 'production';

  const [identity, setIdentity] = useState({});

  const [showActivityForm, setActivityForm] = useState(false);
  const [showCompanyForm, setCompanyForm] = useState(false);
  const [showContactForm, setContactForm] = useState(false);

  const { companyCount, contactCount, orderCount, resetCount } = useContext(CountContext);
  const { selectedCompanyID } = useContext(CompanyContext);
  const { setSearchOptions, activityCount } = useContext(ActivityContext);

  const navigate = useNavigate();
  const location = useLocation();

  const openActivityForm = () => {
    setActivityForm(true);
  };
  const closeActivityForm = () => {
    setActivityForm(false);
  };

  const openCompanyForm = () => {
    setCompanyForm(true);
  };
  const closeCompanyForm = () => {
    setCompanyForm(false);
  };
  
  const openContactForm = () => {
    setContactForm(true);
  };
  const closeContactForm = () => {
    setContactForm(false);
  };

  const logoutUser = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  const navigateToAccount = () => {
    navigate('/account');
  };

  useEffect(() => {
    const getStoredToken = () => {
      return localStorage.getItem('token');
    };
    const storedToken = getStoredToken();
    const fetchAccount = async () => {
      try {
        const identity = jwtDecode(storedToken);
        setIdentity(identity);
      } catch (error) {
        console.error('Error:', error);
      }
    };
    if (storedToken) {
      fetchAccount();
    }
  }, [])

  const easyGift = () => {
    const url = "https://docs.google.com/forms/d/e/1FAIpQLSeR5KaFzItDlWPY9Ds--DQSJBSSfNrcSo-Oa6UL3-rCq3Nt5Q/viewform"
    window.open(url, '_blank');
  };

  const easyNote = () => {
    const url = "https://docs.google.com/forms/d/e/1FAIpQLScbAr0w1mWhUOpsoxt1fBEXEC22aPSkDZ44kAa-eXoYPWMRuQ/viewform"
    window.open(url, '_blank');
  };

  const openMarketing = () => {
    const url = "https://drive.google.com/drive/folders/0AMtkJOr8yabzUk9PVA";
    window.open(url, '_blank');
  };

  const openReports = () => {
    const url = "https://drive.google.com/drive/folders/1-ulLso6ChBAHEue20NGucE6RSx8FpB_m";
    window.open(url, '_blank');
  };

  const goToActivities = () => {
    if (selectedCompanyID>0){
      setSearchOptions({mode: 2, value: selectedCompanyID, data: ""})
    }
    navigate('/activities');
  };

  const goToCompanies = () => {
    navigate('/companies');
  };

  const goToContacts = () => {
    navigate('/contacts');
  };

  const goToOrders = () => {
    navigate('/orders');
  };

  return (
    <header
      {...props}
      className={classes}
    >
      <nav className='navbar navbar-expand-lg nav-profile'>
        <div className='container-fluid'>
          <div className='row top-nav-row'>
            <ul className='nav list-profile col-3 col-md-2'>
              <div className="navbar-brand" to="#">
                <Image
                  src={require('../../assets/images/logo.png')}
                  alt="Open"
                  width={142.142}
                  height={43.9}
                  style={{ cursor: 'pointer' }}
                  onClick={() => goToActivities(true)} />
              </div>
            </ul>
            <div className='d-flex top-nav-padding col-8 col-md-9 ms-md-auto justify-content-end'>
              <div className='top-nav-inner'>
                <button className='btn btn-outline-info btn-profile-easy btn-top' onClick={easyGift}>
                  <Image
                    className="easy-logo"
                    src={require('../../assets/images/Easy_Button_Logo.png')}
                    alt="Easy"
                    width={25}
                    height={25} />
                  <span className='hidden-sm-down'>Gift Portal</span>
                </button>
                <button className='btn btn-outline-info btn-profile-easy btn-top' onClick={easyNote}>
                  <Image
                    className="easy-logo"
                    src={require('../../assets/images/Easy_Button_Logo.png')}
                    alt="Easy"
                    width={25}
                    height={25} />
                  <span className='hidden-sm-down'>Note Portal</span>
                </button>
                <Link className='btn-top-row-mobile'>
                  <Dropdown as={ButtonGroup}>
                    <Dropdown.Toggle variant='top-form-new'>
                      <i className="fa fa-plus-circle sign-in-icon" aria-hidden="true"></i> 
                      <div className='hidden-sm-down'>New</div>
                      <i className="fa fa-caret-down caret-center" aria-hidden="true"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={openActivityForm}>Add Activity</Dropdown.Item>
                      <Dropdown.Item onClick={openCompanyForm}>Add Prospect</Dropdown.Item>
                      <Dropdown.Item onClick={openContactForm}>Add Contact</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Link>
                <button className='btn btn-outline-info btn-profile-pages btn-top' onClick={openReports}>
                  <div className='hidden-sm-down'>Reports</div>
                </button>
                <button className='btn btn-outline-info btn-profile-pages btn-top' onClick={openMarketing} >
                    <div className='hidden-sm-down'>Marketing</div>
                </button>
                <Link>
                  <Dropdown as={ButtonGroup} className='btn-bottom-row-mobile'>
                    <Dropdown.Toggle variant='top-form-new'>
                      <div className='user-button'>
                        <i className="fa fa-fw fa-user-circle sign-in-icon user-button-icon" aria-hidden="true"></i>
                        <div className='hidden-sm-down'>{identity.given_name} {identity.family_name}</div>
                        <i className="fa fa-caret-down caret-center user-button-caret" aria-hidden="true"></i>
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={navigateToAccount}>My Account</Dropdown.Item>
                      <Dropdown.Item onClick={logoutUser}>Logout</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <nav className='navbar navbar-expand-lg nav-pages'>
        <div className='container-fluid'>
          <div className='row nav-pages-inner'>
            <ul className='nav list-companies col-auto'>
              <CompaniesNav dropDownClass="nav-company"/>
            </ul>
            <div className='d-flex col-auto btn-pages-row'>
              <div className='btn-row-wrapper'>
                <button className='btn btn-outline-info btn-pages' onClick={goToActivities}>
                  <div className='hidden-sm-down'>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    <span>Activities</span> ({activityCount})</div>
                </button>
                <button className='btn btn-outline-info btn-pages' onClick={goToCompanies}>
                  <div className='hidden-sm-down'>
                    <i className="fa fa-building" aria-hidden="true"></i>
                    <span>Companies</span> ({companyCount})</div>
                </button>
                <button className='btn btn-outline-info btn-pages' onClick={goToContacts}>
                  <div className='hidden-sm-down'>
                    <i className="fa fa-address-book" aria-hidden="true"></i>
                    <span>Contacts</span> ({contactCount})</div>
                </button>
              {/*  <button className='btn btn-outline-info btn-pages xbtn-underconstruction' onClick={goToOrders}>*/}
              {/*    <div className='hidden-sm-down'>*/}
              {/*      <i className="fa fa-shopping-cart" aria-hidden="true"></i>*/}
              {/*      <span>Orders</span> ({orderCount})</div>*/}
              {/*  </button>*/}
              </div>
            </div>
          </div>
        </div>
      </nav>
      <ActivityForm showModal={showActivityForm} closeModal={closeActivityForm} activityInfo={{}}></ActivityForm>
      <CompanyForm showModal={showCompanyForm} closeModal={closeCompanyForm} companyInfo={{}} openContactForm={openContactForm}></CompanyForm>
      <ContactForm showModal={showContactForm} closeModal={closeContactForm} contactInfo={{}}></ContactForm>
    </header>
  );
}